import React, { Component } from 'react';
import { Session, NavBar, Slider, CarouselDashboard, Footer, MenuCategories, ItemsList } from '../../components';
import { config, VIEW_NAME, SERVICE_API, DISPATCH_ID } from '../../libs/utils/Const';
import { connect } from "react-redux";
import { Prueba } from '../../components/MenuCategories';
import { ApiClient } from "../../libs/apiClient/ApiClient";

const apiClient = ApiClient.getInstance();

class DashboardView extends Component {
    //Crearla funcion ene le store procedure para trear el baner de enmedio
    //en el back, genearar la función par apoder consultarl, similar a lo de categorias ygen errar su ruta
    //front, generar la funcion en Apiclient, g¿enerar la variabla para la ruta de la funcion crada para poder consultar la imgane del banner de enmedio
    state = {
        items: [],//CODIGO DEL PRODUCTO EN UN ARREGLO DE DASH
        categories: [],
        banner: [],
    }
    async componentDidMount() {
        const { setItemsSearch } = this.props
        // console.log('con<#########################################');
        await apiClient.getCategoriesHome().then(result => {
            // console.log('con<<<',result);
            this.setState({
                categories: result.data,
            });
        });
        //Buascar el metodo que busque los productos apartir del itemCode(items)
        await apiClient.getProductsHome().then(result => {
            //Dejar el SEtITEM
            setItemsSearch(result.data);
            this.setState({
                items: result.data,
            });
        });
        await apiClient.getBannerHome().then(result => {
            this.setState({
                banner: result.data,
            });
            // console.log("BANNER->", result.data)
        });

    }
    //Definir variables y metodos

    //Arrows o bien con funiciones declaradas

    mostrarCategoria = (valor) => {
        //Estamos haciendo uso de props del sistema
        // const { itemsReducer: { searchByCategories } } = this.props;
        // searchByCategories(valor);
        const {setCategory,setIdCategory, setLocation,itemsReducer: {searchByCategories},setNextPage} = this.props;
        setIdCategory(valor);
        setNextPage(0);
        setLocation('menuCategories');
        searchByCategories(valor);
    };


    changeQuantity = (index, item, newQuantity, addItem) => {
        const { itemsReducer: { addShoppingCart, deleteShoppingCart } } = this.props;
        if (addItem) {
            addShoppingCart({ item, quantity: (newQuantity || '1') })
        } else {
            deleteShoppingCart({ item, deleteAll: false });
        }
    };

    changeBackOrder = (item, addItem) => {
        const { itemsReducer: { deleteBackOrder, addBackOrder } } = this.props;
        if (addItem) {
            addBackOrder({ item, quantity: 1 })
        } else {
            deleteBackOrder({ item, deleteAll: false });
        }
    };

    //Render va pintar el codigo html que ingresemos en la funcion return 
    render() {



        const { history, itemsReducer: { searchItemsFilter, updateFavorite, deleteShoppingCart, openItemDetails } } = this.props;
        const { categories, items, banner, } = this.state;
        return (

            <div className="content-fluid" style={{ marginTop: 66 }}>

                <Session history={history} view={VIEW_NAME.DASHBOARD_VIEW} />


                <NavBar />
                {/* Si es un video */}
                {config.dashboard === 'Video' && <Slider />}
                {/* Si es un video */}
                {config.dashboard === 'Carousel' && <CarouselDashboard />}

                <div className=".text-justify col-md-12">
                    <p><br></br></p>
                    <h4></h4> 
                </div>


                <div class="container">
                    <div class="row">
                        <div class="col-sm">
                        </div>
                        <div class="col-sm">
                            <h4 className="align-middle text-center">NUESTRAS MARCAS</h4>
                        </div>
                        <div class="col-sm">
                        </div>
                    </div>
                </div>

                <div className="container-fluid row" style={{ paddingTop: 30, margin: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {categories && (categories?.length > 0) && !!categories && categories.map((categoria, index) => {
                        return (
                            <div style={{ margin: 12, position: 'relative', textAlign: 'center' }} key={index}>
                                <div className="item " style={{ width: '16rem', padding: 5, backgroundColor: config.itemsList.backgroundColor }} onClick={() => this.mostrarCategoria(categoria.idCategory)}>
                                    <div>
                                        <img className="card-img-top" style={{ width: '15rem', height: '15rem', backgroundColor: 'white', cursor: 'pointer' }} src={categoria.image ? (config.BASE_URL + SERVICE_API.getImageCategories + '/' + categoria.image) : require('../../images/noImage.png')} />
                                    </div>
                                    <div className="card-body" style={{ margin: 0, padding: 0, color: config.itemsList.textColor }}>
                                        <div className="overflow-auto">
                                            <p className="card-title font-weight-bold text-center" style={{ margin: 0, padding: 0, fontSize: 16, height: '3rem' }}>
                                                {categoria.itemCode}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div >
                    {banner && (banner?.length > 0) && !!banner && banner.map((ban, index) => {
                        return (
                            <div key={index}>
                                <img className="col-md-12 img-fluid"  src={ban.image ? (config.BASE_URL + SERVICE_API.getImageCategories + '/' + ban.image) : require('../../images/noImage.png')}>

                                </img>
                            </div>
                        )
                    })}
                </div>

                <div className=".text-justify col-md-12">
                    <p><br></br></p>
                    <h4></h4>
                </div>

                <div class="container">
                    <div class="row">
                        <div class="col-sm">
                        </div>
                        <div class="col-sm">
                            <h4 className="align-middle text-center">PRODUCTOS DESTACADOS</h4>
                        </div>
                        <div class="col-sm">
                        </div>
                    </div>
                </div>

                {/**funcion y validacion para pintatr los productos */}
                <div className="row mb-4" style={{ paddingTop: 25, margin: 0 }}>
                    <div className="col-md-12 col-sm-12" style={{ margin: 0, minHeight: '70vh' }}>
                        {items && (items?.length>0) &&!!items && items.length !== 0 ? (
                            <ItemsList
                                items={items}
                                updateFavorite={updateFavorite}
                                openDetails={openItemDetails}
                                changeQuantity={this.changeQuantity}
                                deleteShoppingCart={deleteShoppingCart}
                                changeBackOrder={this.changeBackOrder}

                            />
                        ) : (
                                <div style={{ paddingTop: 100, margin: 0, textAlign: 'center' }}>No hay articulos disponibles de momento:
                                    <br />
                                    <br />
                                    <i style={{ fontSize: 70 }} className={config.icons.search}></i>
                                </div>
                            )}
                    </div>
                </div>



            </div >

        );

    }

}

const mapStateToProps = store => {
    return { itemsReducer: store.ItemsReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        setItemsSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SET_ITEMS, value }),
        
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),        
        setItemsFilterSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value }),
        setTotalRows : value => dispatch({type: DISPATCH_ID.ITEMS_SET_TOTALROWS, value}),
        setLocation:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_LOCATION, value}),
        setDashboard:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_DASH, value}),
        searchByDash:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_DASH, value}),
        searchByDashOption: value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_DASH_OPTION, value}),
        setCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_CATEGORY, value}),
        setIdCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_IDCATEGORY, value}),
        setNextPage:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardView);